export const KEY = {
  API_ID: 'API_ID',
  USER_INFO: 'USER_INFO',
  THEME: 'THEME',
  ALL_ALARM: 'ALL_ALARM',
  SOUND: 'SOUND',
  LANGUAGE: 'LANGUAGE',
  CLIENT_ID: 'CLIENT_ID',
  LOGIN_AUTH: 'LOGIN_AUTH_KEY',
};

export const APP_ENV_TYPE = {
  SHOPL: 'SHOPL',
  CPS: 'CPS',
  SSS: 'SSS',
  LOCAL: 'LOCAL',
  DEV: 'DEV',
  QA: 'QA',
};
export type AppEnvType = (typeof APP_ENV_TYPE)[keyof typeof APP_ENV_TYPE];
